import { useTranslationOrText } from '..'
import { MaybeString } from '../../utils'

export const useFieldLabelAndPlaceholder = (
  labelTranslationId: MaybeString,
  label: MaybeString,
  placeholderTranslationId: MaybeString,
  placeholder: MaybeString
) => {
  const fieldLabel = useTranslationOrText(labelTranslationId, label)

  const fieldPlaceholder = useTranslationOrText(
    placeholderTranslationId,
    placeholder
  )

  return { fieldLabel, fieldPlaceholder }
}
